import { Divider } from "antd";

import { KSemiText700, Loading } from "@components";
import { useFetchInfoTypesService } from "@hooks";
import { useListInfoType } from "@store";
import { EFileSort, ICardPractitionerRes } from "@types";
import { useMemo, useState } from "react";
import { PractitionerItem, SortItem } from "../item";
import { CustomSpaceList, WrapperCardList } from "../share-component";
import { getQuery } from "@utils/card";

export const ListPractitioners = () => {
  const {
    pastPractitionerList = [],
    presentPractitionerList = [],
    isLoadingList,
    isLoadingInactiveList,
  } = useListInfoType();
  const [sort, setSort] = useState<EFileSort>(EFileSort.New);

  const query = useMemo(() => getQuery(sort), [sort]);

  useFetchInfoTypesService("Practitioners", query);

  const renderCardItems = (filteredCards: ICardPractitionerRes[] = []) => {
    return filteredCards.map((card: ICardPractitionerRes) => (
      <PractitionerItem key={card._id} card={card} />
    ));
  };

  return (
    <WrapperCardList space={16}>
      <CustomSpaceList>
        <KSemiText700>Practitioners</KSemiText700>
        <SortItem sort={sort} setSort={setSort} />
        {isLoadingList ? <Loading /> : renderCardItems(presentPractitionerList)}
      </CustomSpaceList>
      <Divider />
      <CustomSpaceList>
        <KSemiText700>No Longer Seeing</KSemiText700>
        {isLoadingInactiveList ? (
          <Loading />
        ) : (
          renderCardItems(pastPractitionerList)
        )}
      </CustomSpaceList>
    </WrapperCardList>
  );
};
